import React, { ReactNode } from "react"
import MySwiper from "components/mySlider/mySlider"

interface SliderSectionProps {
    children: ReactNode
    className?: string
}

const SliderSection: React.FC<SliderSectionProps> = ({
    children,

}) => {
    return <MySwiper >
        {children}
    </MySwiper>

}

export default SliderSection